var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/navbar/ic-menu-item"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    d: "M14.5807 14.7184L5.48217 4.64156C4.66491 3.73641 3.93767 3.05594 3.25753 3.67038C2.57747 4.28475 3.18047 5.07673 3.99773 5.98187L13.0962 16.0587C13.9135 16.9639 14.64 17.6444 15.3203 17.0303C16.0008 16.4163 15.3979 15.6236 14.5807 14.7184Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-shape_2",
    d: "M14.5807 6.28144L5.48217 16.3583C4.66491 17.2635 3.93767 17.9439 3.25753 17.3295C2.57747 16.7151 3.18047 15.9232 3.99773 15.018L13.0962 4.94116C13.9135 4.03602 14.64 3.35553 15.3203 3.96953C16.0008 4.5836 15.3979 5.3763 14.5807 6.28144Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.61cf6e5c1da5a67d86d31754df062e75.svg";
export { ForwardRef as ReactComponent };